import React, { useEffect, useState } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import '../components/sidebar.css';
import safrelog from '../safreeimg/safreelogo.png';
import hdrman from '../safreeimg/man.png';
import dashbo from '../safreeimg/superadminimg/dash.png';
import user from '../safreeimg/superadminimg/user.png';
import Organisation from '../safreeimg/superadminimg/orgtion.png';
import Alarm from '../safreeimg/superadminimg/alrm.png';
import checkin from '../safreeimg/superadminimg/checkin.png';
import logout from '../safreeimg/superadminimg/logout.png';
import manual from '../safreeimg/superadminimg/manualnoti.png';
import { onMessageListener } from '../components/firebase.messaging';
import loonotifi from '../safreeimg/safreelogo.png';
import address from '../safreeimg/Group131.png'
import location from '../safreeimg/Group132.png'

// pageslink.. 
import Admin3Page1 from '../components/Admin3/Pages/Page1';
import GuardianGroup from './Admin3/Pages/guardianGroup';
import GuardianSubGroup from './Admin3/Pages/guardianSubGroup';
import GuardianGroupView from './Admin3/Pages/guardianGroupView';
import GuardianSubGroupView from './Admin3/Pages/guardianSubGroupView';
import GuardianAlarms from './Admin3/Pages/guardianAlarm';
import GuardianTotalAlarm from './Admin3/Pages/guardianTotalAlarm';
import GuardianCheckIn from './Admin3/Pages/guardianCheckIn';
import GuardianChat from './Admin3/Pages/guardianChat';
import Notifications from './Admin3/Pages/notifications';
import { ToastContainer, toast } from 'react-toastify';

const Admin3Sidebar = ({ children }) => {
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    "profileImage": '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [notificationData, setNotificationData] = useState({});
  const [showNotification, setShowNotification] = useState(false);



  useEffect(() => {
    // Fetch the profile data from the API
    const fetchProfile = async () => {
      try {
        const response = await fetch('https://api.safree.org/api-v2022/user/my/account/v1/profile', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch profile');
        }

        const data = await response.json();
        const user = data.data.user;

        // Set the profile state with the fetched data
        setProfile({
          name: user.name || 'N/A',
          email: user.email || 'N/A',
          phoneNumber: user.phoneNumber || 'N/A',
          profileImage: user.profileImage || 'N/A',
        });

        // Save the profile data to localStorage
        localStorage.setItem('profile', JSON.stringify({
          name: user.name || 'N/A',
          email: user.email || 'N/A',
          phoneNumber: user.phoneNumber || 'N/A',
          profileImage: user.profileImage || 'N/A',
        }));

      } catch (err) {
        setError(err.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };

    // Try to load profile from localStorage on mount
    const storedProfile = localStorage.getItem('profile');
    if (storedProfile) {
      setProfile(JSON.parse(storedProfile)); // Use the stored profile data
      setLoading(false);
    } else {
      fetchProfile(); // Fetch if no profile is found in localStorage
    }
  }, []);



  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };
  const handleCloseNotification = () => {
    setShowNotification(false);
  };
  useEffect(() => {
    const fetchNotificationData = async () => {
      const unsubscribe = onMessageListener()
        .then((payload) => {
          console.log("🚨 Notification received: ", payload);
          const data = payload?.data || {};

          // ✅ Show notification only if type is "sosAlarm"
          if (data.type === "sosAlarm") {
            setNotificationData({
              location: data.address || "Unknown Location",
              latitude: data.latitude || "N/A",
              longitude: data.longitude || "N/A",
              raisedBy: data.raisedBy || "Unknown",
              guardians: data.guardians || "Unknown",
              dateTime: new Date().toLocaleString(),
              alarmId: data.alarmId || "",
              userName: data.userName || "Guardian",
              image: data.image || "",
            });
            setShowNotification(true);
            toast.info("📢 S.O.S. Alarm Raised!", {
              autoClose: 10000,
            });

            setTimeout(() => {
              setShowNotification(false);
            }, 10000);
          } else {
            console.log("ℹ️ Notification ignored (type is not sosAlarm)");
          }
        })
        .catch((err) => console.log("❌ Notification Error:", err));

      return unsubscribe; // Clean up
    };

    fetchNotificationData();

    const intervalId = setInterval(() => {
      fetchNotificationData();
    }, 3000);

    return () => clearInterval(intervalId);
  }, []);



  const handleChatRedirect = (alarmId) => {
    if (!alarmId) {
      console.warn("Alarm ID missing!");
      return;
    }
    navigate(`/admin3/guardianChat/#${alarmId}`);
  };

  return (
    <div className="app-container">
      <ToastContainer />
      {/* 🔔 Firebase Notification Popup */}
      {showNotification && (
        <div style={{
          position: 'fixed',
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          background: '#fff',
          padding: '24px',
          borderRadius: '20px',
          width: '400px',
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
          fontFamily: 'sans-serif',
        }}>
          <button onClick={handleCloseNotification} style={{
            position: 'absolute',
            top: '16px',
            right: '20px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
          }}>×</button>

          <div style={{ textAlign: 'center', marginBottom: '12px' }}>
            <img src={loonotifi} alt="Safree Logo" style={{ height: '60px' }} />
          </div>

          <h2 style={{ textAlign: 'center', fontWeight: '600', fontSize: '18px', marginBottom: '12px' }}>
            S.O.S. Alarm Raised
          </h2>

          <hr style={{ marginBottom: '16px', borderColor: '#eee' }} />

          <div style={{ display: 'flex', marginBottom: '10px' }}>
            <img src={location} alt="location" style={{ width: '20px', height: '20px', marginRight: '10px' }} />
            <p style={{ fontWeight: '500' }}>{notificationData.location}</p>
          </div>

          <div style={{ display: 'flex', marginBottom: '20px' }}>
            <img src={address} alt="calendar" style={{ width: '20px', height: '20px', marginRight: '10px' }} />
            <p style={{ fontWeight: '500' }}>{notificationData.dateTime}</p>
          </div>

          <div style={{ fontSize: '14px', marginBottom: '8px' }}>
            <span style={{ color: '#888' }}>Alarm Raise By:</span> <span style={{ float: 'right' }}>{notificationData.raisedBy}</span>
          </div>
          <div style={{ fontSize: '14px', marginBottom: '20px' }}>
            <span style={{ color: '#888' }}>Guardians:</span> <span style={{ float: 'right' }}>{notificationData.guardians}</span>
          </div>

          <div style={{ fontSize: '14px', marginBottom: '8px' }}>
            <span style={{ color: '#888' }}>Latitude:</span> <span style={{ float: 'right' }}>{notificationData.latitude}</span>
          </div>
          <div style={{ fontSize: '14px', marginBottom: '8px' }}>
            <span style={{ color: '#888' }}>Longitude:</span> <span style={{ float: 'right' }}>{notificationData.longitude}</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* <button style={{
              backgroundColor: '#000',
              color: '#fff',
              padding: '10px 24px',
              borderRadius: '50px',
              fontWeight: '600',
              cursor: 'pointer',
              border: 'none',
              flex: 1,
              marginRight: '10px',
            }}>
              View Details
            </button> */}
            <button
              onClick={() => {
                setShowNotification(false);
                handleChatRedirect(notificationData.alarmId, notificationData.userName, notificationData.image);
              }}
              style={{
                backgroundColor: '#000',
                color: '#fff',
                padding: '10px 24px',
                borderRadius: '50px',
                fontWeight: '600',
                cursor: 'pointer',
                border: 'none',
                flex: 1,
              }}
            >
              Chat
            </button>

          </div>
        </div>
      )
      }
      {/* Sidebar */}
      <aside className="sidebar">
        <ul>
          <NavLink
            to="/admin3/dashboard"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={dashbo} alt="Dashboard Icon" />
              </span>
              Dashboard
            </li>
          </NavLink>
          <NavLink
            to="/admin3/guardianGroup"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={user} alt="User Management Icon" />
              </span>
              My Groups
            </li>
          </NavLink>
          <NavLink
            to="/admin3/guardianSubGroup"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={Organisation} alt="Organisation Icon" />
              </span>
              My Sub Groups
            </li>
          </NavLink>
          <NavLink to="/admin3/guardianTotalAlarm"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }>
            <li className="sidebar-item">
              <span className="icon">
                <img src={Alarm} alt="Alarm Management Icon" />
              </span>
              Alarm Management
            </li>
          </NavLink>

          <NavLink to="/admin3/guardianCheckIn"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }>
            <li className="sidebar-item">
              <span className="icon">
                <img src={checkin} alt="CheckIn Management Icon" />
              </span>
              CheckIn Management
            </li>
          </NavLink>
          <NavLink to="/admin3/notifications"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }>
            <li className="sidebar-item">
              <span className="icon">
                <img src={manual} alt="Notification Icon" />
              </span>
              Notifications
            </li>
          </NavLink>

          {/* Logout Button */}
          <li className="sidebar-item sidebar-items sidebar-link" onClick={handleLogout}>
            <span className="icon">
              <img src={logout} alt="Logout Icon" />
            </span>
            Logout
          </li>
        </ul>
        <ul className='sidpriv sidprivs '>
          <a href="https://safree.org/Terms&Conditions.html" target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </a>
          <a href="https://safree.org/privacy.html" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </ul>

      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="app-header">
          <div className="logo">
            <img src={safrelog} alt="Logo" />
          </div>
          <div className="profile">
            <img
              src={profile.profileImage && profile.profileImage !== 'N/A' ? profile.profileImage : hdrman}
              alt="Profile"
            />
            <div className="prifiledata">
              {loading ? (
                <h3>Loading...</h3>
              ) : error ? (
                <h3>{error}</h3>
              ) : (
                <>
                  <h3>Name: {profile.name}</h3>
                  <h3>Email: {profile.email}</h3>
                  <h3>Phone Number: {profile.phoneNumber}</h3>
                </>
              )}
            </div>

          </div>
        </header>
        <div className="content">
          {children}
          <Routes>
            <Route path="dashboard" element={<Admin3Page1 />} />
            <Route path="guardianGroup" element={<GuardianGroup />} />
            <Route path="guardianSubGroup" element={<GuardianSubGroup />} />
            <Route path="/guardianGroup/guardianGroupView" element={<GuardianGroupView />} />
            <Route path="/guardianSubGroup/guardianSubGroupView" element={<GuardianSubGroupView />} />
            <Route path="guardianAlarms" element={<GuardianAlarms />} />
            <Route path="guardianTotalAlarm" element={<GuardianTotalAlarm />} />
            <Route path="guardianCheckIn" element={<GuardianCheckIn />} />
            <Route path="guardianChat" element={<GuardianChat />} />
            <Route path="notifications" element={<Notifications />} />
          </Routes>
        </div>
      </main>
    </div >
  );
};

export default Admin3Sidebar;
